<template>
  <div style="display: none;">
  </div>
</template>

<script>
export default {
  name: 'CheckboxEditor',
  data () {
    return {
      value: null
    }
  },
  mounted () {
    if (this.params.colDef.editable &&
        this.params.value !== '#NA#' &&
        this.params.value !== '#NREF#') {
      this.value = !(this.params.value && this.params.value.toString() === 'true')
      this.params.node.setDataValue(this.params.column, this.value)
    }

    if (this.params.value === '#NA#' || this.params.value === '#NREF#') {
      this.params.stopEditing()
    } else {
      this.params.stopEditing()
      this.params.api.refreshCells()
    }
  },
  methods: {
    getValue () {
      return this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/CheckboxEditor.vue